import React from 'react';

// Primary Vibe URL
const VIBE_BASE_URL = 'https://vibe.hirex8.com';

/**
 * VibeLink - A link component for Vibe platform URLs
 * 
 * Usage:
 * <VibeLink path="/register" params="?type=talent" className="btn">Join Now</VibeLink>
 * <VibeLink path="/register" className="btn">Join Now</VibeLink>
 */
const VibeLink = ({ 
  path = '', 
  params = '',
  children, 
  className = '',
  ...props 
}) => {
  const href = `${VIBE_BASE_URL}${path}${params}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      {...props}
    >
      {children}
    </a>
  );
};

export default VibeLink;
